import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { socket } from 'src/socket';

// export const socketConnect = createAsyncThunk('socket/connect', async () => {
    
//     const socketId = await new Promise((resolve, reject) => {
//         socket.connect();
//         socket.on('connect', () => {
//             const socketId = socket.id;
//             resolve(socketId)
//         });
//         socket.on('connect_error', (error) => reject(error));
//     });

//     return {
//         socketId : socketId
//     }
// });

// export const socketDisconnect = createAsyncThunk('socket/disconnect', async () => {
//     return await new Promise((resolve, reject) => {
//         socket.disconnect((reason) => {
//           resolve();
//         });
//     });
// });


const initialState = {
    isConnected: false,
    socketId: null
}

export const socketSlice = createSlice({
    name: 'socket',
    initialState,
    reducers: {
        connect : (state, action) => {
            state = {
                isConnected: true,
                socketId :action.payload.socketId
            };
            return state;
        },
        disconnect: (state, action) => {
            state = initialState;
            return state;
        }
    }
})

// Action creators are generated for each case reducer function
export const { connect, disconnect } = socketSlice.actions
export default socketSlice.reducer;